var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[([this.userRole].includes('admin'))?[_c('admin')]:([this.userRole].includes('partner'))?[_c('partner')]:([this.userRole].includes('media'))?[_c('media')]:([this.userRole].includes('agency'))?[_c('agency')]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }